
export interface TitleDetail {
  title?: string;
  subtitle?: string;
}

export const TitleMapper: Record<string, TitleDetail> = {
  GAD7: {
    title: "GAD-7 (for Anxiety) - Please select one to the following",
    subtitle:
      "The Generalized Anxiety Disorder 7-item (GAD-7) is a easy to perform initial screening tool for generalized anxiety disorder.",
  },
  PHQ9: {
    title: "PHQ-9 (for Depression) - Please select one to the following",
    subtitle:
      "The PHQ-9 is a multipurpose instrument for screening, diagnosing,monitoring and measuring the severity of depression.",
  },
  MDQ: {
    title: "Mood Disorder Questionnaire (MDQ)",
    subtitle:
      "Employing the Mood Disorder Questionnaire (MDQ) to screen for potential mood disorders.",
  },
  CAGE: {
    title: "CAGE (for Alcohol) - Please answer Yes or No for the following",
    subtitle:
      "CAGE is a 4-item questionnaire that can indicate potential problems with alcohol use.",
  },
  SUBSTANCE_ABUSE: {
    title: "DAST-10 (for Substance Abuse)",
    subtitle:
      "The DAST-10 is a 10-item self-report tool used to screen for drug abuse and dependence within the past 12 months.",
  },
};

// const DrawerTitleMapper: Record<string, string> = {
//   GAD7: "GAD7",
//   PHQ9: "PHQ9",
//   SUBSTANCE_ABUSE: "Substance Abuse",
//   CAGE: "Cage",
//   MDQ: "MDQ",
// };
